jQuery(document).ready(function($) {
    const $blocks = $('.wp-block-jormi-blocks-booking-form');

    if ($blocks.length) {
        // Initialize each block separately
        $blocks.each(function(index) {
            const $block = $(this);
            const blockId = 'booking-block-' + index;
            
            // Add a unique identifier to this block instance
            $block.attr('data-block-id', blockId);
            
            // Initialize variables for this form instance
            let startDate = null;
            let endDate = null;
            const defaultAdults = 1;
            const defaultChildren = 0;
            const defaultRooms = 1;
            
            // Store original texts before we begin
            storeDefaultTexts();
            
            // Initialize all components
            initDatePicker();
            initRoomSelection();
            initGuestSelection();
            initFormSubmission();
            
            // Use blockId to create scoped selectors
            function getSelector(selector) {
                return $block.find(selector);
            }
            
            // Initialize date range picker
            function initDatePicker() {
                // Create datepicker container with unique ID
                const datePickerId = 'booking-datepicker-' + index;
                const datePickerContainer = $('<div id="' + datePickerId + '"></div>');
                
                // Find the datepicker wrapper within this block instance
                const datePickerWrapper = getSelector(".datepicker-wrapper");
                datePickerWrapper.html('').append(datePickerContainer);
                
                // Initialize jQuery UI Datepicker with unique ID
                $("#" + datePickerId).datepicker({
                    numberOfMonths: 2,
                    dateFormat: 'yy-mm-dd',
                    minDate: 0,
                    beforeShowDay: function(date) {
                        if (!startDate && !endDate) return [true, ''];
                        
                        let currentDate = $.datepicker.formatDate('yy-mm-dd', date);
                        let classes = '';
                        
                        // Check if it's the start date
                        if (startDate && currentDate === startDate) {
                            classes = 'ui-datepicker-range-start';
                        }
                        // Check if it's the end date
                        else if (endDate && currentDate === endDate) {
                            classes = 'ui-datepicker-range-end';
                        }
                        // Check if it's in between
                        else if (startDate && endDate && currentDate > startDate && currentDate < endDate) {
                            classes = 'ui-datepicker-range-between';
                        }
                        
                        return [true, classes];
                    },
                    onSelect: function(dateText) {
                        let selectedDate = dateText;
                        
                        if (!startDate || (startDate && endDate) || (startDate && selectedDate < startDate)) {
                            // Start new selection
                            startDate = selectedDate;
                            endDate = null;
                            getSelector(".checkInDate").val(selectedDate);
                            getSelector(".checkOutDate").val('');
                        } else {
                            // Complete the selection
                            endDate = selectedDate;
                            getSelector(".checkOutDate").val(selectedDate);
                            
                            // Update display text on the button
                            updateDateButtonText();
                        }
                        
                        $(this).datepicker("refresh");
                    }
                });
                
                // Connect clear button - scoped to this block
                getSelector("#booking-date-group .hs-dropdown-menu button").on('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    
                    // Reset all state
                    startDate = null;
                    endDate = null;
                    getSelector(".checkInDate").val('');
                    getSelector(".checkOutDate").val('');
                    
                    // Completely rebuild the datepicker
                    $("#" + datePickerId).datepicker("destroy");
                    initDatePicker();
                    
                    const $dateButton = getSelector("#hs-dropdown-dates");
                    $dateButton.text($dateButton.data('default-text'));
                });
                
                // Prevent dropdown from closing when interacting with datepicker
                $("#" + datePickerId).on('click', function(e) {
                    e.stopPropagation();
                });
            }
            
            // Format date string (YYYY-MM-DD) to display format (e.g., Mar 24)
            function formatDisplayDate(dateString) {
                if (!dateString) return '';
                
                // Parse the date parts directly from the string to avoid timezone issues
                let parts = dateString.split('-');
                let year = parseInt(parts[0]);
                let month = parseInt(parts[1]) - 1; // months are 0-based in JS
                let day = parseInt(parts[2]);
                
                // Month names for display
                const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                
                return monthNames[month] + ' ' + day;
            }
            
            // Update the date button text based on selection
            function updateDateButtonText() {
                const $dateButton = getSelector("#hs-dropdown-dates");
                
                if (startDate && endDate) {
                    // Format dates using our custom function
                    let formattedStartDate = formatDisplayDate(startDate);
                    let formattedEndDate = formatDisplayDate(endDate);
                    
                    $dateButton.text(formattedStartDate + ' - ' + formattedEndDate);
                } else if (startDate) {
                    let formattedStartDate = formatDisplayDate(startDate);
                    $dateButton.text(formattedStartDate + ' - Select checkout');
                } else {
                    $dateButton.text($dateButton.data('default-text'));
                }
            }
            
            // Initialize room selection
            function initRoomSelection() {
                const $roomButton = getSelector("#hs-dropdown-room");
                
                // Save default text
                $roomButton.data('default-text', $roomButton.text());
                
                // Set default room value
                getSelector(".rooms").val(defaultRooms);
                updateRoomButtonText(defaultRooms);
                
                // Room options click handler
                getSelector(".room-option").on('click', function() {
                    let roomValue = $(this).data('value');
                    getSelector(".rooms").val(roomValue);
                    updateRoomButtonText(roomValue);
                    // Close dropdown after selection
                    setTimeout(function() {
                        const openDropdown = $block.find(".hs-dropdown-toggle[aria-expanded='true']");
                        if (openDropdown.length) openDropdown[0].click();
                    }, 100);
                });
                
                // Clear room selection button
                getSelector("#booking-room-group .hs-dropdown-menu button").on('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    getSelector(".rooms").val('');
                    $roomButton.text($roomButton.data('default-text'));
                });
            }
            
            // Update room button text
            function updateRoomButtonText(roomCount) {
                const $roomButton = getSelector("#hs-dropdown-room");
                
                if (roomCount && roomCount > 0) {
                    $roomButton.text(roomCount + (roomCount === 1 ? ' room' : ' rooms'));
                } else {
                    $roomButton.text($roomButton.data('default-text'));
                }
            }
            
            // Initialize guest selection
            function initGuestSelection() {
                const $guestButton = getSelector("#hs-dropdown-guests");
                
                // Save default text
                $guestButton.data('default-text', $guestButton.text());
                
                // Set default values
                getSelector(".adults-input").val(defaultAdults);
                getSelector(".children-input").val(defaultChildren);
                updateGuestButtonText();
                
                // Handle guest number changes
                getSelector(".adults-input, .children-input").on('change', function() {
                    updateGuestButtonText();
                });
                
                // Clear guest selection button
                getSelector("#booking-guests-group .hs-dropdown-menu button").on('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    getSelector(".adults-input").val(defaultAdults);
                    getSelector(".children-input").val(defaultChildren);
                    updateGuestButtonText();
                });
            }
            
            // Update guest button text
            function updateGuestButtonText() {
                const $guestButton = getSelector("#hs-dropdown-guests");
                let adults = parseInt(getSelector(".adults-input").val()) || 0;
                let children = parseInt(getSelector(".children-input").val()) || 0;
                
                if (adults > 0 || children > 0) {
                    let guestText = '';
                    if (adults > 0) {
                        guestText += adults + (adults === 1 ? ' adult' : ' adults');
                    }
                    if (children > 0) {
                        guestText += (adults > 0 ? ', ' : '') + children + (children === 1 ? ' child' : ' children');
                    }
                    $guestButton.text(guestText);
                } else {
                    $guestButton.text($guestButton.data('default-text'));
                }
            }
            
            // Form validation and submission
            function initFormSubmission() {
                const $form = getSelector("form");
                
                $form.on('submit', function(e) {
                    // Basic validation
                    let valid = true;
                    let errorMessage = '';
                    
                    if (!getSelector(".checkInDate").val() || !getSelector(".checkOutDate").val()) {
                        errorMessage = 'Please select check-in and check-out dates';
                        valid = false;
                    }
                    
                    let adults = parseInt(getSelector(".adults-input").val()) || 0;
                    if (adults < 1) {
                        errorMessage = 'At least 1 adult is required';
                        valid = false;
                    }
                    
                    let rooms = parseInt(getSelector(".rooms").val()) || 0;
                    if (rooms < 1) {
                        errorMessage = 'At least 1 room is required';
                        valid = false;
                    }
                    
                    if (!valid) {
                        e.preventDefault();
                        alert(errorMessage);
                        return false;
                    }
                    
                    return true;
                });
            }
            
            // Store dropdown default texts
            function storeDefaultTexts() {
                const $datesButton = getSelector("#hs-dropdown-dates");
                const $guestsButton = getSelector("#hs-dropdown-guests");
                const $roomButton = getSelector("#hs-dropdown-room");
                
                $datesButton.data('default-text', $datesButton.text());
                $guestsButton.data('default-text', $guestsButton.text());
                $roomButton.data('default-text', $roomButton.text());
            }
        }); // End of each() loop
        
        // Load necessary styles once for all instances
        $('<link>').appendTo('head').attr({
            type: 'text/css', 
            rel: 'stylesheet',
            href: 'https://code.jquery.com/ui/1.13.2/themes/base/jquery-ui.css'
        });
    }
});